import {KeypadControlsMainGameState} from '@gongxigames/framework/slot/modules/keypadControls/states/KeypadControlsMainGameState';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {KeypadControlsModule} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsModule';

export class KeypadControlsFreeGamesState extends KeypadControlsMainGameState {

    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinsOutroFinished();
        }
    }

    protected onFreeSpinsOutroFinished(): void {
        this.module.gotoState(KeypadControlsModule.BASIC_STATE);
    }

    protected onBigWinEnded(): void {

    }

    protected onAutoplayStarted(): void {
        this.module.gotoState(KeypadControlsModule.FREESPINS_AUTOPLAY_STATE);
    }
}
